// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_29-3";
export var dialog = "_29-0";
export var divClassnameSwatch = "_29-8";
export var flexSwatch = "_29-4";
export var header = "_29-1";
export var styleAttributeSwatch = "_29-7";
export var swatch = "_29-2";
export var textHeaderSwatch = "_29-5";
export var webSwatch = "_29-6";